export * from './dees-label.js';
